import api from "./Axios";

const getBaseUrl = () => {
  if (api?.defaults?.baseURL) return api.defaults.baseURL;
  return process.env.REACT_APP_SERVER_ADDRESS || window.location.origin || "";
};

export const resolveMediaUrl = (path = "") => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith("data:")) return path;

  const base = getBaseUrl().replace(/\/+$/, "");
  if (!base) return path;

  if (path.startsWith("/")) return `${base}${path}`;
  return `${base}/${path}`;
};
